import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/tailwind.css'
import '@/assets/scss/style.scss'
import 'boxicons'
import VueQuillEditor from 'vue-quill-editor'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
/*! purgecss start ignore */
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
/*! purgecss end ignore */
import VueTheMask from 'vue-the-mask'
import '@/components/global'
import Toasted from 'vue-toasted'
import VueGtag from 'vue-gtag'
import VueClipboard from 'vue-clipboard2'
import VueCurrencyInput from 'vue-currency-input'
import VueApexCharts from 'vue-apexcharts'
import Moment from 'vue-moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCubes,
  faSave,
  faListAlt,
  faUserSecret,
  faBox,
  faTimes,
  faSearch,
  faCog,
  faPen,
  faBell,
  faUser,
  faEye,
  faTrashAlt,
  faHeart,
  faPlus,
  faLink,
  faArrowLeft,
  faArrowRight,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import EsticoSettings from '@/utils/settings'
/***
 *  Font Awesome
 */
library.add(
  faCubes,
  faListAlt,
  faSave,
  faUserSecret,
  faInfoCircle,
  faTimes,
  faSearch,
  faBox,
  faPen,
  faCog,
  faBell,
  faUser,
  faEye,
  faTrashAlt,
  faHeart,
  faPlus,
  faLink,
  faArrowLeft,
  faArrowRight
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
/**
 *
 *  Apex Chart
 */
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false

Vue.use(VueTheMask)
Vue.use(VueFormWizard)
Vue.use(Moment)
Vue.use(Toasted)
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GTAG }
  },
  router
)
Vue.use(VueClipboard)

Vue.filter('toCurrency', function(value) {
  if (!value) {
    value = 0
  }
  return parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
})

const pluginOptions = {
  /* see config reference */
  globalOptions: {
    currency: 'BRL',
    autoDecimalMode: true,
    distractionFree: false
  }
}
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(VueQuillEditor)

Vue.prototype.$settings = EsticoSettings

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
